<script lang="ts">
  import Swal from 'sweetalert2';
  import {STEP} from '@/types/common';
  import {step, project, subtitles, ProjectState, recap} from '@/store';
  import {triggerOnSeek} from '@components';
  import disabled from '@/store/disabled';

  import VideoPlayer from './VideoPlayer.svelte';

  import {Container} from '@components';

  import {topnav} from '@/utils/top-nav-next-custom-events';
  import {onDestroy, onMount} from 'svelte';
  import Subtitle from './Subtitle.svelte';
  import {Timestamp, TimestampText} from '@/store/recap';
  import {RecapService} from '@/services';

  $: $disabled = $project.selectedSentences.length === 0;

  const recapService = new RecapService();

  const updateNextStep = async () => {
    if (timestamps.length <= 0) {
      openSwal();
      return;
    }

    try {
      // save project then generate AI suggested intro

      const timestamps = transcriptions
        .filter(text => text.isHighlighted === true)
        .map(text => ({startDuration: text.timeStart, endDuration: text.timeEnd})) as Timestamp[];

      const updatedRecapData = await recapService.update(recap_id, {step: STEP.SELECT_INTRO, timestamps});

      recap.update(value => {
        if (!updatedRecapData.suggested_intros) return value;
        console.log('SUGGEST INTRO UPDATE');
        value.suggested_intros = updatedRecapData.suggested_intros;
        return value;
      });

      // get senetences if exists
      step.update(STEP.SELECT_INTRO);
    } catch (error) {
      Swal.fire({
        text: 'Something went wrong saving your sermon recap. Please try again',
        icon: 'error',
        titleText: 'Failed to save Sermon Recap'
      });
    }
  };

  const updatePrevStep = async () => {
    step.update(STEP.CHOOSE_VIDEO);
    recapService.update(recap_id, {
      step: STEP.CHOOSE_VIDEO
    });
  };

  const openSwal = () => {
    Swal.fire({
      text: 'Please select atleast one (1) subtitle to continue.',
      icon: 'warning',
      titleText: 'Warning No Subtitle Selected'
    });
  };

  let recap_id: number = -1;
  let videoSrc = '';
  let timestamps: Timestamp[] = [];
  let transcriptions: TimestampText[] = [];

  const recapSubscription = recap.subscribe(value => {
    if (value.video_src) videoSrc = value.video_src;
    recap_id = value.id;
    timestamps = value.timestamps || [];
    transcriptions = value.transcription || [];
  });

  const updateTimestamp = (event: any) => {
    recap.update(value => {
      value.timestamps = event.detail.timestamps || [];
      return value;
    });
  };

  const onTimeUpdate = (e: {detail: {videoTime: number; currentTime: number}}) => {
    const event = e.detail;
    for (let i = 0; i < timestamps.length; i++) {
      const timestamp = timestamps[i];

      if (event.videoTime >= timestamp.startDuration && event.videoTime <= timestamp.endDuration) {
        for (let j = timestamp.startIndex; j <= timestamp.endIndex; j++) {
          const transcription = transcriptions[j];
          transcription.isFollowingText = false;
          if (event.videoTime >= transcription.timeStart && event.videoTime <= transcription.timeEnd) {
            transcription.isFollowingText = true;
          }
        }
        continue;
      }

      for (let j = timestamp.startIndex; j <= timestamp.endIndex; j++) {
        transcriptions[j].isFollowingText = false;
      }
    }

    transcriptions = transcriptions;
  };

  onMount(() => {
    topnav.disabledNext(openSwal);
    topnav.next(updateNextStep);
    topnav.previous(updatePrevStep);
  });

  onDestroy(() => {
    recapSubscription();
  });
</script>

<Container className="flex">
  <Subtitle {transcriptions} {timestamps} on:timestamp-change={updateTimestamp} />
  <div class="relative flex h-full flex-grow items-center overflow-auto">
    <VideoPlayer {videoSrc} {timestamps} on:timeupdate={onTimeUpdate} />
  </div>
</Container>
